import React from 'react';
import "./Registration.css";
import Img_1 from "../../images/Registration1.png";
import Img_2 from "../../images/Registration2.jpg";
import Img_3 from "../../images/Registration3.jpg";

import Img1 from "../../images/box-1.jpg";
import Img2 from "../../images/box-2.jpg";
import Img3 from "../../images/box-3.jpg";
import Img4 from "../../images/box-4.jpg";
import Img5 from "../../images/box-5.jpg";



const registration = () => {
  const worries = [
    {
      title: "Preparing the RM Application",
      description:
        "The registered manager is often the focus of significant scrutiny. Typical worries include whether the manager has sufficient experience and qualifications, how to answer the fit person interview questions, and demonstrating an understanding of relevant regulations and responsibilities.",
    },
    {
      title: "Delays and uncertainty in the registration process",
      description:
        "One of the most frequent frustrations is not knowing how long registration will take.",
    },
  ];

  return (
    <>
    <section className="registration">

      <section className="registration-bar">
         <h1 className="registration-title">Navigating CQC Registration with Confidence</h1>
          <p className="registration-pera">Total Care Advisory simplifies the complex CQC registration process, guiding you every step <br/>
          of the way to ensure a smooth and successful journey for your care business.<br/><br/>
          We will manage your application, produce compliant documentation and prepare you for interview so you can register with confidence
          
          </p>
            <button className='registration-btn'>Let's get started</button>
      </section>

      <section className='registration-cue'>

          <div className="common-worries">
            <div className="common-worries__image">
              <img src={Img_1} alt="CQC Registration Concerns"/>
            </div>

            <div className="common-worries__content">
              <h2>Common worries during CQC registration</h2>

              <p className="intro">
                Many care providers find the CQC registration process daunting.
                Some of the biggest challenges our clients typically face include:
              </p>

              {worries.map((item, index) => (
                <div key={index} className="worry-item">
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>
                </div>
              ))}
            </div>
          </div>
          <div className="common-worries">
        <div className="common-worries__content">
          <h2>How we simplify your CQC journey</h2>

          <p className="intro">
           Total Care Advisory makes the CQC registration process simpler and less stressful for care providers. We guide you through every
           stage, helping you understand exactly what the CQC expects and ensuring your application is completed correctly from the start.
          </p>
          <p className="intro">Our team produces essential documentation, including policies, procedures, statements of purpose, a CQC compliant business 
            plan and other compliance requirements. We also help prepare registered managers for CQC interviews, giving them the confidence 
            to demonstrate their knowledge and suitability.</p>
          <p className="intro">By reviewing your application thoroughly before submission, we help reduce common mistakes that can cause delays or requests 
            for further information. We also provide practical advice on governance, safeguarding, recruitment, and quality assurance systems
             so your service is ready to meet CQC standards.</p>
        </div>

        <div className="common-worries__image">
          <img src={Img_2} alt="CQC Registration Concerns"/>
        </div>
          </div>
          <div className="common-worries">
            <div className="common-worries__image">
              <img src={Img_3} alt="CQC Registration Concerns"/>
            </div>

            <div className="common-worries__content">
              <h2>Achieving peace of mind and success</h2>

              <p className="intro"> After successfully achieving CQC registration, most clients feel a huge sense of relief and confidence.
                 What often seemed like a complex and overwhelming process is finally complete, and they can move forward knowing their 
                 service meets regulatory requirements.
              </p>
              <p className="intro">Our clients feel reassured that their policies, procedures, and governance systems are in place and aligned with CQC expectations. They gain greater confidence in their ability to operate safely, effectively, and compliantly from day one.</p>
              <p className="intro">Many providers also experience a great sense of pride (and excitement), as registration marks a major milestone in turning their vision into a fully regulated care service. With approval secured, they can focus on recruiting staff, supporting 
                service users, tendering to local authorities, growing their business, and delivering high-quality care.</p>
              <p className="intro">Beyond obtaining registration, clients often value the knowledge and understanding they have gained throughout the process and leave feeling better prepared for future inspections.</p>

             
            </div>
          </div>
      </section>

      <section className="cqc-registration">
      <h2 className="section-title">
        CQC Registration - What's Included
      </h2>

      <div className="cards-grid">

        <div className="Registration-cards">
          <img
            src={Img1}
            alt="Policies & Procedures"
          />
          <h3>Policies & Procedures</h3>
        </div>

        <div className="Registration-cards">
          <img
            src={Img2}
            alt="Statement of Purpose"
          />
          <h3>Statement of Purpose</h3>
        </div>

        <div className="Registration-cards">
          <img
            src={Img3}
            alt="Business Plan"
          />
          <h3>CQC Compliant Business Plan</h3>
        </div>

        <div className="Registration-cards">
          <img
            src={Img4}
            alt="Business Plan"
          />
          <h3>All Application Forms</h3>
        </div>

        <div className="Registration-cards">
          <img
            src={Img5}
            alt="Business Plan"
          />
          <h3>RM Interview Preparation</h3>
        </div>

      </div>
      </section>
    </section>   
    </>
  )
}

export default registration
